<template>
  <v-card>
    <v-toolbar class="cyan" dark flat>
      <v-toolbar-title>Automatische Metadatenerfassung</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>help</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <div class="body-2 grey--text">Ziehen Sie die Dateien mit den Datensätzen auf dieses Feld, um die Metadaten automatisch zu erfassen.</div>
      <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-success="fileAdded"></vue-dropzone>

      <v-dialog v-model="showDialog" :width="1020" persistent>
        <v-card>
          <v-card-title class="headline">Automatische Metadatenerfassung</v-card-title>
          <v-card-text>
            <div class="body-2 grey--text">Folgende Metadaten wurden erkannt. Korrigieren und bestätigen Sie die erfassten Daten, um mit der Bearbeitung fortzufahren.</div>
          </v-card-text>
          <v-data-table
            :headers="headers"
            :items="uploadedFiles"
            :search="search"
            v-model="selected"
            :rows-per-page-text="'Zeilen pro Seite'"
            item-key="name"
            select-all
          >
            <template slot="headerCell" scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" scope="props">
              <td>
                <v-checkbox
                  primary
                  hide-details
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>{{ props.item.name }}</td>
              <td class="text-xs-right">{{ props.item.title }}</td>
              <td class="text-xs-right">{{ props.item.source }}</td>
              <td class="text-xs-right">{{ props.item.contact }}</td>
              <td class="text-xs-right">{{ props.item.language }}</td>
              <td class="text-xs-right">{{ props.item.date }}</td>
              <td class="text-xs-right">{{ props.item.lastModified }}</td>
            </template>
          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="addSelectedFiles" :disabled="!selected.length" :loading="filesBeingAdded">Ausgewählte hinzufügen ({{ selected.length }})</v-btn>
            <v-btn flat @click.native="showDialog = false">Abbrechen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'

export default {
  name: 'automated-metadata-scanner',
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      showDialog: this.show,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        dictDefaultMessage: 'Dateien oder Ordner hochladen'
      },
      uploadedFiles: [],
      filesBeingAdded: false,
      search: '',
      selected: [],
      headers: [
        {
          text: 'Dateiname',
          align: 'left',
          value: 'name'
        },
        { text: 'Titel', value: 'title' },
        { text: 'Quelle', value: 'source' },
        { text: 'Ansprechpartner', value: 'contact' },
        { text: 'Sprache', value: 'language' },
        { text: 'Datum', value: 'date' },
        { text: 'Zuletzt bearbeitet', value: 'lastModified' }
      ]
    }
  },
  methods: {
    fileAdded (file) {
      console.log('file added', file)
      this.uploadedFiles.push(file)
      let fakeData = {
        title: 'Liste der Berliner Badestellen',
        source: 'Landesamt für Gesundheit und Soziales',
        contact: 'Landesamt für Gesundheit und Soziales',
        description: 'Landesamt für Gesundheit und Soziales',
        language: 'Deutsch',
        date: '2017-08-05'
      }

      for (var p in fakeData) this.uploadedFiles[0][p] = fakeData[p]

      this.showDialog = true
    },
    addSelectedFiles () {
      this.filesBeingAdded = true

      var that = this
      setTimeout(function () {
        that.$store.dispatch('demoUploadDatasetMeta').then((dataset) => {
          that.filesBeingAdded = false
          that.showDialog = false
          that.$store.dispatch('loadResource', dataset.id)
        })
      }, 1400)
    }
  },
  props: ['show']
}
</script>

<style>

.vue-dropzone {
  font-family: inherit !important;
  margin-top: 20px;
  outline: 5px dashed #efefef;
  outline-offset: -5px;
  border: none;
}

#dropzone, .dropzone {
  min-height: 100px !important;
  padding: 16px;
}

.dz-image {
  width: 190px !important;
  height: 190px !important;
}

.dropzone .dz-preview {
  margin: 2px; 
}

.dropzone .dz-preview, .dropzone .dz-preview:hover {
  z-index: 3 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/IntelligentMetadataScanner.vue